import { render, staticRenderFns } from "./NominationConferenceList.vue?vue&type=template&id=23c9f176&scoped=true"
import script from "./NominationConferenceList.vue?vue&type=script&lang=js"
export * from "./NominationConferenceList.vue?vue&type=script&lang=js"
import style0 from "./NominationConferenceList.vue?vue&type=style&index=0&id=23c9f176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c9f176",
  null
  
)

export default component.exports